
{
  "fr": {
    "printBtn": "Voir mon fichier d'impression",
    "either": "soit",
    "unit": "/ unité"
  }
}
